module.exports = __webpack_public_path__ + "static/img/retail-small.32163ae.jpg";